import React from "react";
import { X, Hand, MousePointerClick, ZoomIn, MoveHorizontal } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { btnPrimary } from "@/components/Brand";

/** Shown once per gallery: explains grid → full screen → tap to select → swipe → pinch. */
export const SelectionOnboarding = ({ onClose }) => {
  const { t } = useI18n();
  const steps = [
    { icon: MousePointerClick, text: t("ob_tap_open") },
    { icon: MoveHorizontal, text: t("ob_swipe") },
    { icon: Hand, text: t("ob_tap_select") },
    { icon: ZoomIn, text: t("ob_pinch") },
  ];
  return (
    <div className="fixed inset-0 z-[70] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
      <div data-testid="selection-onboarding" className="w-full max-w-md bg-[#0F0F0F] border border-[#2A2A2A] p-7 sm:p-9 fade-up">
        <div className="flex items-start justify-between gap-4 mb-7">
          <div>
            <p className="eyebrow mb-2">{t("ob_eyebrow")}</p>
            <h2 className="text-2xl sm:text-3xl tracking-tighter font-medium">{t("ob_title")}</h2>
          </div>
          <button data-testid="onboarding-close-btn" onClick={onClose} aria-label={t("close")}
            className="text-[#707070] hover:text-[#F3F3F1]">
            <X size={20} />
          </button>
        </div>
        <ul className="space-y-5">
          {steps.map((s) => (
            <li key={s.text} className="flex items-start gap-4">
              <s.icon size={18} strokeWidth={1.4} className="text-[#D4AF37] mt-0.5 shrink-0" />
              <span className="text-sm text-[#A8A8A8] leading-relaxed">{s.text}</span>
            </li>
          ))}
        </ul>
        <button data-testid="onboarding-start-btn" onClick={onClose} className={`${btnPrimary} w-full mt-9 py-4`}>
          {t("ob_start")}
        </button>
      </div>
    </div>
  );
};
